<template>
  <img
    :src="currentSrc"
    :alt="alt"
    loading="lazy"
    class="image-with-fallback"
    @error="onError"
  />
</template>

<script>
  export default {
    name: 'ProductImage',
    props: {
      src: {
        type: String,
        required: false,
        default: '',
      },
      alt: {
        type: String,
        default: 'Image',
      },
      fallbackSrc: {
        type: String,
        default: () => require('@/assets/image/no-image.png'),
      },
    },
    data() {
      return {
        currentSrc: this.src,
      }
    },
    created() {
      this.syncSource(this.src)
    },
    watch: {
      src: {
        immediate: false,
        handler(value) {
          this.syncSource(value)
        },
      },
    },
    methods: {
      syncSource(value) {
        if (typeof value === 'string' && value.trim()) {
          this.currentSrc = value
          return
        }

        this.currentSrc = this.fallbackSrc
      },
      onError() {
        this.currentSrc = this.fallbackSrc
      },
    },
  }
</script>

<style scoped>
  .image-with-fallback {
  width: 40px;
  height: 40px;
  object-fit: cover;
  display: block;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid #e9ecef;
  background-color: #fff;
  transition: transform 0.3s ease;
  cursor: pointer;
}
.image-with-fallback:hover {
  transform: scale(3);
  z-index: 1000;
}
</style>
